import {endpoints} from "App"
export async function callAnalytics(customerDetails: any, eventType: String) {

    const {
        APP_ANALYTICS_JOURNEY,
        APP_ANALYTICS_PATH,
        APP_ANALYTICS_KEY
    }= endpoints;
    console.log(" endpoints : ", endpoints);
    console.log(" customerDetails : ", customerDetails);
    let logParams = {
        "eventType": eventType,
        "CID": customerDetails.customerID,
        "FirstName": customerDetails.customerName || "",
        "LastName": customerDetails.lastName || "",
        "PhoneNo": customerDetails.customerPh ? `+1${customerDetails.customerPh}` : "",
        "JourneyName": APP_ANALYTICS_JOURNEY
      };

    try {
        return fetch(APP_ANALYTICS_PATH, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "x-api-key": `${APP_ANALYTICS_KEY}`
            },
            body: JSON.stringify(logParams)
        });
    } catch (error) {
        console.log(error);
    }
    return false
}